<div [formGroup]="formGroup">
  <label [for]="controlName" class="block text-sm font-medium">{{ label }}</label>
  <textarea
    [id]="controlName"
    [formControlName]="controlName"
    class="delay-50 border-1 form-input mt-1 block w-full rounded-md border-dark-blue shadow-sm transition ease-in focus:border-medium-green focus:ring focus:ring-medium-green focus:ring-opacity-50"
  ></textarea>
  <app-form-errors [fieldName]="controlName" />
</div>
